import { makeStyles } from "@material-ui/core";

export default makeStyles(({ spacing }) => ({
  modalRoot: {
    width: "480px",
    padding: spacing(3, 3, 2, 3),
    backgroundColor: "white",
    borderRadius: "8px",
  },
  paper: {
    textAlign: "center",
  },
  text: {
    fontWeight: "lighter",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  loaderContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    zIndex: 9999,
  },
}));
